module.exports = __webpack_public_path__ + "static/covolo-c538e6e9116c1624780383ae7527f063.jpg";